import React from "react";
import { Col, Row } from "react-bootstrap";
import "./flexiaccesssummaryofchanges.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { addCommas } from "../../helpers/helpers";
import { Link } from "react-router-dom";
import NotFound from "../../atoms/NotFound";

const FlexiAccessSummaryOfChangesModal = (props) => {
  return (
    <div
      className={
        props?.data !== undefined
          ? "parent-flexi-access-summary-changes"
          : "parent-felxi-access-confirm"
      }
    >
      <Row>
        <Col>
          <div className="summary-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row
        className={
          props?.data !== undefined
            ? "summary-title mb-5"
            : "confirm-pop-title mb-2"
        }
      >
        <Col>
          <div>{props.modaltitle}</div>
        </Col>
      </Row>
      {props?.data !== undefined ? (
        <>
          <Row className="summary-of-change mb-5 d-none d-xl-block d-lg-block d-md-block">
            <Col>
              <table>
                <thead>
                  <tr>
                    <th className="ps-4">Fund</th>
                    <th className="col-pad-allocation">Allocation</th>
                    {props.investmentStrategyKey === "futurePaymentsOnly" ? (
                      ""
                    ) : (
                      <th className="col-pad-total-value">Current value</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {props.data
                    ?.filter(
                      (fund) =>
                        !(
                          (
                            fund.fundPercentage1 === 0 &&
                            fund.fundPercentage2 === 0
                          ) // eslint-disable-line
                        ),
                    )
                    .map((item, index) => {
                      return (
                        <tr className="mt-3" key={index}>
                          <td className="ps-4">
                            <span>{item.fundName}</span>
                          </td>
                          <td className="col-pad-allocation">
                            {item.fundPercentage1}%{" "}
                            <Icons
                              iconname="arrow-right-fuchsia"
                              variant="icon-sixteen-px"
                            />{" "}
                            <b>{item.fundPercentage2}%</b>
                          </td>
                          {props.investmentStrategyKey ===
                          "futurePaymentsOnly" ? (
                            ""
                          ) : (
                            <td className="col-pad-total-value">
                              £{addCommas(Math.trunc(item.balance2))}.
                              <span className="eac-pot-value-small-digit">
                                {(item.balance2 % 1).toFixed(2).substring(2)}
                              </span>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Col>
          </Row>
          <Row className="summary-of-change mb-5 d-block d-sm-none">
            <Col>
              <table>
                <thead>
                  <tr>
                    <th className="ps-4">Fund</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data
                    ?.filter(
                      (fund) =>
                        !(
                          fund.fundPercentage1 === 0 &&
                          fund.fundPercentage2 === 0
                        ), // eslint-disable-line
                    )
                    .map((item, index) => {
                      return (
                        <tr className="mt-3" key={index}>
                          <td className="ps-4">
                            <div className="mobile-fund-name">
                              {item.fundName}
                            </div>
                            <div className="mobile-allocation">
                              <Row>
                                <Col>
                                  <span>Allocation</span>
                                  <div>
                                    <span className="mobile-value">
                                      {item.fundPercentage1}%
                                    </span>{" "}
                                    <Icons
                                      iconname="arrow-right-fuchsia"
                                      variant="icon-sixteen-px"
                                    />{" "}
                                    <span className="mobile-percentage-bold">
                                      {item.fundPercentage2}
                                    </span>
                                  </div>
                                </Col>
                                {props.investmentStrategyKey ===
                                "futurePaymentsOnly" ? (
                                  ""
                                ) : (
                                  <Col>
                                    <span>Current Value</span>
                                    <div className="mobile-value">
                                      £{addCommas(Math.trunc(item.balance2))}.
                                      <span className="eac-pot-value-small-digit">
                                        {(item.balance2 % 1)
                                          .toFixed(2)
                                          .substring(2)}
                                      </span>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Col>
          </Row>
          {props.fundSwitchError && props.errorShown === true ? (
            <div className="mb-3">
              <NotFound err={props.fundSwitchError} />
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <div>
          <div className="confirm-title mb-2">
            Thank you, we have received your change investment request.
          </div>
          {props.investmentStrategyKey !== "futurePaymentsOnly" ? (
            <div className="confirm-desc">
              Changes can take up to 5 working days to display on your account
              and we will notify you when it is available to view. Until this
              happens, you won&apos;t be able to edit investments for the pot
              that you have just updated.
            </div>
          ) : (
            ""
          )}
        </div>
      )}
      {props?.data !== undefined ? (
        <Row className="text-bottom">
          <Col
            className="summary-desc text-bottom mb-3"
            xl={8}
            lg={8}
            md={8}
          ></Col>
          <Col xl={4} lg={4} md={4}>
            <div className="summary-footer-button">
              <div className="summary-cancel-button">
                <Buttons
                  name="Cancel"
                  className="secondary"
                  variantname="icon-sixteen-px"
                  handleClick={props.handleCloseButton}
                ></Buttons>
              </div>
              <div>
                <Buttons
                  name="Confirm"
                  className="primary"
                  variantname="icon-sixteen-px"
                  handleClick={props.handleContinue}
                  fundSwitchFetching={props.fundSwitchFetching}
                  fundSwitchFutureFetching={props.fundSwitchFutureFetching}
                ></Buttons>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <div className="confirm-button">
          <Buttons
            name="Continue"
            className="primary"
            variantname="icon-sixteen-px"
            handleClick={props.handleContinue}
          ></Buttons>
        </div>
      )}
    </div>
  );
};

export default FlexiAccessSummaryOfChangesModal;
